import packingSlipPdfGenerateWithPrice from './packing-slip-pdf-generate-with-price'
import packingSlipPdfGenerateWithoutPrice from './packing-slip-pdf-generate-without-price'

/**
 * Packing Slip PDF Generator - Main Entry
 * 根据 showPriceOnPackingSlip 参数自动选择使用含价格或不含价格版本
 *
 * @param data - 订单数据
 * @param require - 操作类型 ('getBlob' 或其他)
 * @param getBlob - 获取 blob 的回调函数
 * @param filename - 文件名
 */
export default async (data: any, require?: string, getBlob?: any, filename?: string) => {
  const needPrice = data.customer?.customer?.showPriceOnPackingSlip

  if (needPrice) {
    // 使用含价格版本
    return packingSlipPdfGenerateWithPrice(data, require, getBlob, filename)
  } else {
    // 使用不含价格版本
    return packingSlipPdfGenerateWithoutPrice(data, require, getBlob, filename)
  }
}
